import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';
// :: Services & Products | Adber Infra India Pvt. Ltd. ::
const Services = () => {
    useEffect(() => {
        document.title = ":: Services & Products | Adber Infra India Pvt. Ltd. ::";
    }, []);
    return (
        <div>
            <Header />
            <section className="inner-page-banner-area products">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className="title"> Services & Products </h1>
                                <p className="description"> We are good in quality and services; this is highly appreciated in the market.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <nav className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/">Home</Link></li>
                        <li>Services & Products</li>
                    </ol>
                </div>
            </nav>

            <section className="container" id="InternalPageArea">
                <div className="row tabStyles">
                    <div className="col-sm-12 col-xs-12 ">
                        <ul className="nav nav-tabs" role="tablist" id="services-tabber">
                            <li role="presentation" className="active"><Link to="#home" aria-controls="home" role="tab" data-toggle="tab"> Infrastructure & Facilities In Our Plant </Link></li>
                            <li role="presentation"><Link to="#profile" aria-controls="profile" role="tab" data-toggle="tab"> Added Value To Ready Mixed Concrete </Link></li>
                            <li role="presentation"><Link to="#messages" aria-controls="messages" role="tab" data-toggle="tab"> Highly Equipped Lab of Ready Mix Concrete </Link></li>
                        </ul>

                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <img src="../assets/images/service-1.jpg" alt="Infrastructure & Facilities In Our Plant" title="Infrastructure & Facilities In Our Plant" />
                                <span className="tagline1"> Building it better in Concrete </span>
                                <ul className="commanListstyle">
                                    {/* List items */}
                                    <li> Transit Mixers and Chassis mounted Line Pumps to ensure proper transportation and easy pumping.</li>
                                    <li> Fully automated Ready Mix Concrete. </li>
                                    <li> High cubic meter capacity. </li>
                                    <li> Fully equipped onsite plant laboratory.</li>
                                    <li> High storage capacity silo for cement available.</li>
                                    <li> Best imported planetary mix batching plant for perfect homogenous mix. Extra machine & equipments also readly available.</li>
                                    <li> Raw material from only approved and selected sources as per IS stipulations.</li>
                                    <li> Totally computerized production & quality software available. </li>
                                    <li> Experienced team to serve your concrete requirements on time.</li>
                                    <li> Efficient concrete design mixes to ensure proper strength and quality.</li>
                                </ul>
                            </div>

                            <div role="tabpanel" className="tab-pane" id="profile">
                                <img src="../assets/images/service-2.jpg" alt="Added Value To Ready Mixed Concrete" title="Added Value To Ready Mixed Concrete" />
                                <ul className="commanListstyle">
                                    {/* List items */}
                                    <li> Convenient, Comfortable and Economical. </li>
                                    <li> Tested and Trusted Concrete. </li>
                                    <li> Water Cement ratio maintained at any cost. </li>
                                    <li> Consistent, Uniform and assured quality of concrete. </li>
                                    <li> Defined proportions of ingredients according to Design mix. </li>
                                    <li> Mix design of Concrete as per I.S. Specifications.</li>
                                    <li> Ingredients Batching by Weight.</li>
                                    <li> Faster, Smoother scheduled hassle free construction.</li>
                                    <li> Minimize Manpower and Material Management.</li>
                                    <li> Accelerates the construction speed.</li>
                                    <li> Value for money and time.</li>
                                    <li> Flexibility in choice of concrete.</li>
                                    <li> Very low pollution level. </li>
                                </ul>
                            </div>

                            <div role="tabpanel" className="tab-pane" id="messages">
                                <img src="../assets/images/service-3.jpg" alt="Engineering Properties of Ready Mix Concrete" title="Engineering Properties of Ready Mix Concrete" />
                                <p> Any type of construction works requires concrete as a basic material. The concrete mixture is made up of different ingredients like cement, sand, water, aggregates and admixtures. In India, the use of RMC (Ready Mix Concrete) is increased due to its advantages in comparison with traditional concrete mixture. It is type of concrete which is produced under controlled conditions using consistent quality of raw materials. The advantage of RMC like speed of construction can be very fast, reduction in cement consumption by 10 to 12 percent due to better handling and proper mixing, versatility in using and methods of placing of concrete, it uses bulk cement instead of bagged cement so dust pollution will be less and reduced and with better durability of structure their overall service life is increased and there is saving in life cycle cost it is mostly used at the construction site. In this paper, the main focus is to check various engineering properties of materials which are used in the preparation of RMC. The tests are conducted in laboratories and results and its comparison is checked. </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Our RMC Products </h3>
                    </div>
                    <div className="col-sm-12 col-xs-12 ">
                        <p> Adber Infra India Pvt. Ltd. is a major provider of Ready Mix Concrete for luxury residential and infrastructure projects in and around Pune, Maharashtra. It is currently handling projects valued at over Rs. 800 crores which are under various stages of execution.</p>
                        <p> We provide Ready Mix Concrete (RMC) of various grades on demand As per Requirements. </p>

                        <ul className="commanListstyle">
                            <li> Pumpable Concrete </li>
                            <li> Flowable Concrete </li>
                            <li> Self Compacting Concrete </li>
                            <li> Light weight Concrete</li>
                            <li> Drylean Concrete </li>
                            <li> Pavement Quality Concrete </li>
                            <li> Stamping Concrete </li>
                            <li> High Density Concrete </li>
                            <li> High Strength Concrete </li>
                        </ul>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Work at Glance </h3>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <video width="100%" height="400" controls>
                            <source src="../assets/videos/quality-dept-video.mp4" type="video/mp4" />
                        </video>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default Services;
